export default {"src":"/_next/static/media/typewriter.63dc96a6.svg","height":558,"width":722};